import { Expose } from "class-transformer";

export class MoveWorksheetDto {
  @Expose()
  projectId: string;

  @Expose()
  worksheetId: string;
}
